module.exports = __webpack_public_path__ + "static/media/postman_auth_projects.25708e6b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/postman_auth_projects.png
 ** module id = 1247
 ** module chunks = 0
 **/